export const API_KEY = "AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw";
